import React from 'react'
import InspectionmobCard from './InspectionCard'

function MobileInspectionIndex({data,getData}) {
  return (
    <div>
       <div className="w-full h-[calc(100vh-199px)] overflow-y-auto py-1 px-2">
    
          {data &&
            data.map((item, index) => (
              <InspectionmobCard item={item} getData={getData} key={index} />
            ))}
            
      </div>
    </div>
  )
}

export default MobileInspectionIndex
